export const setShips = items => ({
    type: 'SET_SHIPS',
    items,
});
